// extracted by mini-css-extract-plugin
export default {"page":"Qr_page__kS78+","main":"Qr_main__Vm0dF","image":"Qr_image__3Uisz","link":"Qr_link__sLYdG"};